import React, { Component } from "react"
import { Link } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import styled from "@emotion/styled"

import { AppConsumer } from "../../context/context"
import { isBrowser, signOut } from "../../services/firebase"

export class LoginButton extends Component {
  render() {
    return (
      <AppConsumer>
        {value => {
          if (isBrowser) {
            const {
              firebaseApp,
              isAuthenticated,
              profile,
              unreadAlerts,
            } = value

            if (isAuthenticated) {
              return (
                <>
                  <div className="navbar-item is-hidden-touch is-hidden-desktop-only">
                    {unreadAlerts && unreadAlerts > 0 ? (
                      <Link to={"/app/notifications"} className="button">
                        <span className="icon has-text-link">
                          <FontAwesomeIcon icon="bell" />
                        </span>
                        <span>{unreadAlerts}</span>
                      </Link>
                    ) : null}
                  </div>
                  <div className="navbar-item has-dropdown is-hoverable is-hidden-touch is-hidden-desktop-only">
                    <div className="navbar-link">
                      {profile && profile.name ? profile.name : "LFS User"}
                    </div>
                    <div className="navbar-dropdown is-right">
                      <Link className="navbar-item" to="/app/post/opportunity">
                        Post New Opportunity
                      </Link>
                      <Link className="navbar-item" to="/app/bizbio">
                        My bizb.io
                      </Link>
                      <Link className="navbar-item" to="/app/profile">
                        My Account
                      </Link>
                      <Link className="navbar-item" to="/app/notifications">
                        My Notifications
                      </Link>
                      <Link
                        className="navbar-item"
                        to={`/app/posts-by-user/${
                          firebaseApp.auth.currentUser
                            ? firebaseApp.auth.currentUser.uid
                            : null
                        }`}
                      >
                        My Posts
                      </Link>
                      <Link className="navbar-item" to="/app/liked-posts">
                        Liked Posts
                      </Link>
                      <HoverableDiv
                        className="navbar-item"
                        onClick={signOut.bind(this, firebaseApp)}
                      >
                        Log Out
                      </HoverableDiv>
                    </div>
                  </div>
                </>
              )
            } else {
              return (
                <div className="navbar-item is-hidden-touch is-hidden-desktop-only">
                  <div className="buttons">
                    <Link to="/app/login" className="button">
                      Log In
                    </Link>
                    <Link
                      to="/app/signup"
                      state={{
                        signupPayload: null,
                      }}
                      className="button is-link"
                    >
                      Sign Up
                    </Link>
                  </div>
                </div>
              )
            }
          } else {
            return <React.Fragment></React.Fragment>
          }
        }}
      </AppConsumer>
    )
  }
}

const HoverableDiv = styled.div`
  cursor: pointer;
  font-weight: bold;
  :hover {
    background-color: whitesmoke;
    color: #2b2523;
  }
`

export default LoginButton
